import buildBasicInformation from './BasicInformation';
import RegistrationAndLegal from './RegistrationAndLegal';
import ContactInformation from './ContactInformation';
import VeteranStatusSection from './VeteranStatus';
import buildDisabilitiesSection from './Disabilities';

const buildApplicationInformationSection = ({
  isAffordable = false,
  isFinanciallyResponsible = false,
  propertyStateCode,
  affordablePrograms,
  applicantTypeName = null,
  affordableRelationship = null,
}) => {
  const shouldShowDisabilitiesSection =
    isAffordable &&
    applicantTypeName !== 'Live-In-Caretaker' &&
    affordableRelationship !== 'Live-In Caretaker';

  return {
    name: 'applicationInformation',
    title: 'Application Information',
    container: 'default',
    divider: true,
    fields: [
      buildBasicInformation({
        isAffordable,
        propertyStateCode,
        affordablePrograms,
      }),
      ...(shouldShowDisabilitiesSection
        ? [
            buildDisabilitiesSection({
              affordablePrograms,
            }),
          ]
        : []),
      ...(isAffordable ? [VeteranStatusSection] : []),
      RegistrationAndLegal,
      ContactInformation,
    ],
  };
};

export default buildApplicationInformationSection;
